export default __webpack_public_path__ + "img/bgevents.jpg?d1ba";